import { StatefulDropdown } from "./StatefulDropdown";
import I18n, { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { EllipsisDropdownItem } from "@similarweb/ui-components";
import type { IDeviceFilterItem } from "app/pages/app-intelligence/common-components/device-picker/types";
import { getRelevantDevicesList } from "../utils/dashboardWizardUtils";

type DashboardWizardDeviceFilterItem = IDeviceFilterItem & { iconName: string };

interface IDashboardWizardChannelSelectionProps {
    isActive: boolean;
    selectedDevice: string;
    widgetKeys: any[];
    changeDevice: (device: string) => void;
    navigationState: string;
}

const DashboardWizardDevice: FC<IDashboardWizardChannelSelectionProps> = ({
    isActive,
    selectedDevice,
    widgetKeys,
    changeDevice,
    navigationState,
}) => {
    const [deviceList, setDeviceList] = useState<DashboardWizardDeviceFilterItem[]>([]);
    const translate = useTranslation();

    useEffect(() => {
        if (!isActive) {
            return;
        }
        if (widgetKeys?.length) {
            const updatedDeviceList: IDeviceFilterItem[] = getRelevantDevicesList(
                widgetKeys[0].store,
                widgetKeys.map((k) => k.id),
                navigationState,
            );
            const transformedDeviceList: DashboardWizardDeviceFilterItem[] = updatedDeviceList.map((d) => ({
                ...d,
                iconName: d.icon,
            }));
            setDeviceList(transformedDeviceList);
        } else {
            setDeviceList([]);
        }
    }, [isActive, widgetKeys?.[0]?.store, widgetKeys?.length, navigationState]);

    const onSelect = (item) => {
        changeDevice(item);
    };

    return isActive ? (
        <div className="device">
            <h5>
                <I18n>home.dashboards.wizard.filters.device</I18n>
            </h5>
            <StatefulDropdown
                key={"devices"}
                items={deviceList}
                selectedId={selectedDevice}
                onSelect={onSelect}
                disabled={!widgetKeys?.length}
                title={translate("home.dashboards.wizard.filters.device.placeholder")}
                DropDownItemComponent={EllipsisDropdownItem}
            />
        </div>
    ) : null;
};

export default DashboardWizardDevice;
